jQuery('document').ready(function(){

    jQuery('.w3-order-lookup').on('DOMSubtreeModified',function()
    {
        jQuery('#findOrder').val("Cauta comanda");
    });

    jQuery('.menu_level2_click').click(function(){
        return false;
    })

    if(jQuery( window ).width()<768){

        jQuery('.engoj-btn-addtocart').click(function(){
            jQuery('.minicart').addClass('active');
        })
    }


    jQuery('.farbpalette-anfordern').click(function(){
        jQuery('.farbpalette-option').removeClass('activatefarbpalette');
        jQuery(this).addClass('activatefarbpalette');
        jQuery('#FARBEN').show();
      //  jQuery('#default_FARBEN').hide()
        jQuery('.link_color').removeClass('activatecolor');
        jQuery('#FARBEN .maxus-color:first-of-type .link_color').addClass('activatecolor');
        s = jQuery('.activatefarbpalette').data('value') + ' ' + jQuery('.activatecolor').data('color') ;
        jQuery('#customproperty').val(s);
    })

    comanda_personaizata = 'https://api.whatsapp.com/send?phone=40310051532&text=Bună, aș vrea paletarul pentru produsul: ' + jQuery('.product-title').text()
    comanda_personaizata_jquery = '<a href="' + comanda_personaizata +'" target="_blank" class="link_custom_whatsapp"> COMANDA PERSONALIZATA SOLICITA PALETAR</a>'
    jQuery('label[for="swatch-0-comanda-personalizata-solicita-paletar"]').html(comanda_personaizata_jquery)
    jQuery('label[for="swatch-1-comanda-personalizata-solicita-paletar"]').html(comanda_personaizata_jquery)
    
    /*
    jQuery('.grundfarbe').click(function(){
        jQuery('.farbpalette-option').removeClass('activatefarbpalette');
        jQuery(this).addClass('activatefarbpalette');
        jQuery('#FARBEN').hide();
        jQuery('#default_FARBEN').show()
        jQuery('.link_color').removeClass('activatecolor');
        jQuery('#default_FARBEN .maxus-color:first-of-type .link_color').addClass('activatecolor');
        s = jQuery('.activatefarbpalette').data('value') + ' ' + jQuery('.activatecolor').data('color') ;
        jQuery('#customproperty').val(s);
        console.log(jQuery('#customproperty').val());
    })*/

    jQuery('.link_color').click(function(){
        jQuery('.link_color').removeClass('activatecolor');
        jQuery(this).addClass('activatecolor');
        s = jQuery('.activatefarbpalette').data('value') + ' ' + jQuery('.activatecolor').data('color') ;
        jQuery('#customproperty').val(s);
        console.log(jQuery('#customproperty').val());
    })

    jQuery('a').removeAttr('target')

});